import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from "../shared";
import {
  GlCategoryListContainerModel,
  GlcodeContainerModel
} from "../../../../../models/aggregates/payment-configuration";


@Injectable({
  providedIn: 'root'
})
export class GlcategorylistService extends BaseApiTemplateService<GlCategoryListContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'glcategory-lists';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'glcategory-lists';
    this.httpClient = http;
  }
}
